import { Box } from "@mui/material";
import Lottie from "lottie-react";
import animationData from "./animation/openDoorAnimation-Black.json";

const DoorOpenAnimation = () => {
  return (
    <div className="flex flex-col justify-center items-center">
      <Lottie
        style={{
          width: 300,
          height: 300,
        }}
        animationData={animationData}
        loop={true}
      />
    </div>
  );
};

export default DoorOpenAnimation;
